import { Placement } from "@floating-ui/utils";

/**
 * Map Floating-UI library popover position name to Spark's popover position
 * @param  {string} term Name of Floating-UI's position
 * @return {string}      Name of Spark position
 */
export const matchPositionKey = (term: string): Placement | undefined => {
  switch (term) {
    case "center-top":
      return "top";
    case "center-bottom":
      return "bottom";
    case "right-bottom":
      return "bottom-start";
    case "right-middle":
      return "right";
    case "right-top":
      return "top-start";
    case "left-bottom":
      return "bottom-end";
    case "left-middle":
      return "left";
    case "left-top":
      return "top-end";
    default:
      return "bottom";
  }
};
